import axios from "@/plugins/axios";

let url = "/api/v1/nanuri/charge";

export const charge = {
    /**
     * @param {{ token: string }} data
     * @returns {Promise<{ success: boolean, message?: string }>}
     */
    post(data) {
        return axios.post(url, data).then((result) => result.data);
    },
};

export default charge;
